import { BordPhoto, BordTextButton, TbordOneToneIcon } from 'bord-design-system';
import { CLIENT_PLAN_TYPES } from 'types/client.types';
import { EQuoteType, IQuoteApiResponse } from 'types/quote.types';
import QuoteEditorMetaDataItem from './QuoteEditorMetaDataItem/QuoteEditorMetaDataItem';
import QuoteStatusRow from 'views/Quote/components/QuoteStatusRow/QuoteStatusRow';
import { bordColorTheme } from '../../../../../styles/styles.constants';
import './QuoteEditorHeader.scss';

interface IQuoteEditorHeader {
  quoteDetails: IQuoteApiResponse;
  onSaveAndExit: () => void;
  isSaving?: boolean;
}

const PLAN_TYPE_LABELS: Partial<Record<CLIENT_PLAN_TYPES, string>> = {
  [CLIENT_PLAN_TYPES.STANDARD]: 'Standard',
  [CLIENT_PLAN_TYPES.FREE]: 'Standard',
  [CLIENT_PLAN_TYPES.PLATINUM]: 'Platinum',
  [CLIENT_PLAN_TYPES.LITE]: 'Platinum',
  [CLIENT_PLAN_TYPES.VIP]: 'VIP'
};

/**
 * Banner superior del editor de cotización con la info general de la cotización
 * y el botón de guardar y salir.
 */
const QuoteEditorHeader = ({ quoteDetails, onSaveAndExit, isSaving }: IQuoteEditorHeader) => {
  const {
    id,
    organizationName,
    organizationId,
    requestedCountry,
    quoteType,
    parentQuoteId,
    organizationSubscriptionLevel,
    quoteStatus
  } = quoteDetails;

  const quoteTitle = 'Crear cotización';
  const quoteTypeLabel = quoteType?.code === EQuoteType.REGULAR ? 'Regular' : 'Exploratoria';
  const organizationTypeLabel = organizationSubscriptionLevel
    ? PLAN_TYPE_LABELS[organizationSubscriptionLevel] ?? organizationSubscriptionLevel
    : '-';

  const metaItems = [
    { label: 'N°', value: String(id), icon: null },
    { label: 'Cliente:', value: organizationName, icon: 'externalLink' as const, organizationId },
    { label: 'Tipo de cliente:', value: organizationTypeLabel },
    { label: 'Tipo de cotización:', value: quoteTypeLabel },
    { label: 'País:', value: requestedCountry?.name, flagUrl: requestedCountry?.flag }
  ];

  return (
    <div className="quoteEditorHeader">
      <div className="headerLeft">
        <BordPhoto
          url={undefined}
          variant="square"
          size="s56"
          oneToneIconProps={{
            variant: 'filePlus',
            standardSize: 32,
            stroke: bordColorTheme.navyBlue[500],
            strokeWidth: 1
          }}
        />
        <div className="quoteInfo">
          <div className="quoteTitleAndStatus">
            <div className="quoteTitle">{quoteTitle}</div>
            <QuoteStatusRow quoteId={id} quoteStatus={quoteStatus} parentQuoteId={parentQuoteId} />
          </div>
          <div className="quoteMeta">
            {metaItems.map(item => (
              <QuoteEditorMetaDataItem
                key={item.label}
                label={item.label}
                value={item.value}
                icon={item.icon as TbordOneToneIcon}
                flagUrl={item.flagUrl}
                organizationId={item.organizationId}
              />
            ))}
          </div>
        </div>
      </div>
      <BordTextButton
        text="Guardar y salir"
        onClick={onSaveAndExit}
        isDisabled={isSaving}
        leftIconProps={{ variant: 'arrowLeft', standardSize: 12, stroke: bordColorTheme.primary.fgDefault }}
        className="exitQuoteEditorHeaderBtn"
      />
    </div>
  );
};

export default QuoteEditorHeader;
